import { useState } from 'react';
import Reveal from '@/components/feature/Reveal';
import SectionHeading from './SectionHeading';
import { faqs } from '@/mocks/guide';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24 border-y border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-8 lg:gap-14">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              kicker="FAQ"
              title="投稿常见问题"
              desc="关于实名、时效、格式与安全，这里整理了投稿者最常问的几个问题。没找到答案可以直接在下方投稿入口留言。"
            />
            <Reveal delay={80}>
              <a
                href="#submit"
                className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-foreground-950 text-background-50 text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
              >
                <i className="ri-question-answer-line" aria-hidden="true" />
                还有疑问？去投稿入口留言
              </a>
            </Reveal>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <Reveal key={faq.q} delay={index * 50}>
                  <div
                    className={`rounded-lg border overflow-hidden transition-colors ${
                      isOpen ? 'bg-background-50 border-primary-300' : 'bg-background-50 border-background-200'
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                      >
                        <span className="flex items-start gap-3">
                          <span className={`font-heading text-sm font-bold ${isOpen ? 'text-primary-600' : 'text-foreground-400'}`}>
                            {String(index + 1).padStart(2, '0')}
                          </span>
                          <span className="font-heading font-medium text-base text-foreground-950">{faq.q}</span>
                        </span>
                        <i
                          className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-xl text-foreground-500 shrink-0`}
                          aria-hidden="true"
                        />
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-[3.1rem]">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}